export default function navigationToggle() {
    const toggleButton = document.querySelector('.js-navtoggle');
    const header = document.querySelector('.js-header');
    const body = document.querySelector('body');

    if (toggleButton) {
        toggleButton.addEventListener('click', () => {
            header.classList.toggle('is-open');
            body.classList.toggle('scrolllock');

            if (toggleButton.getAttribute('aria-expanded') === 'true') {
                toggleButton.setAttribute('aria-expanded', 'false');
                toggleButton.setAttribute('aria-label', 'Menü öffnen');
            } else {
                toggleButton.setAttribute('aria-expanded', 'true');
                toggleButton.setAttribute('aria-label', 'Menü schließen');
            }
        });
    }
}
